import { RunInstanceLog } from "src/models/runInstance";
import { createEntityModel } from "src/store/models/entity/_shared";

export const RunInstanceLogEntityModel = createEntityModel<RunInstanceLog>();
